import React from "react";
import * as S from "./Styles";

interface ImageProps {
  src: string;
  alt: string;
  width?: string;
  height?: string;
  useShadow?: boolean;
  useRadius?: boolean;
}

const Image = ({
  src,
  alt,
  width,
  height,
  useShadow,
  useRadius,
}: ImageProps) => {
  return (
    <S.Img
      src={src}
      alt={alt}
      width={width}
      height={height}
      $useShadow={useShadow}
      $useRadius={useRadius}
    />
  );
};

export default Image;
